import { cn } from 'cn';

type P = ComponentStyling;

export const BetaBadge = ({ className, style }: P) => {
  return (
    <span
      className={cn(
        'inline-block rounded-sm bg-tiga-semantic-info px-1.25 py-0.25 text-xs text-white',
        className,
      )}
      style={style}
    >
      Beta
    </span>
  );
};
